import { fromJS } from 'immutable';
import {
  CHANGE_PROJECT_LIST_FILTERS,
  CHANGE_PROJECT_LIST_SEARCH,
  CHANGE_PROJECT_LIST_VIEW,
  CLEAR_PROJECT_FORM_ERRORS,
  LOAD_PROJECTS_SUCCESS,
  TOGGLE_PROJECT_FORM,
} from 'constants/ActionTypes';

const initialState = fromJS({
  search: null,
  viewType: 'cards',
  dataset: [],
  filters: {
    leader: 'all',
    responsible: 'all',
    services: 'all',
    status: 'active',
  },
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
  form: {
    isVisible: false,
    projectId: null,
    errors: null,
  },
});

const projectListReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PROJECT_LIST_SEARCH:
      return state.set('search', action.search);
    case LOAD_PROJECTS_SUCCESS: {
      if (action.fromList) {
        return state.merge(
          fromJS({
            pagination: {
              totalCount: action.projects._meta.totalCount,
              pageCount: action.projects._meta.pageCount,
              currentPage: action.projects._meta.currentPage,
              perPage: action.projects._meta.perPage,
            },
            dataset: action.projects.items.map((project) => project.projectId),
          }),
        );
      }
      return state;
    }
    case CHANGE_PROJECT_LIST_VIEW:
      return state.set('viewType', action.view);
    case CHANGE_PROJECT_LIST_FILTERS:
      return state.set('filters', state.get('filters').merge(fromJS(action.filters)));
    case CLEAR_PROJECT_FORM_ERRORS:
      return state.setIn(['form', 'errors'], null);
    case TOGGLE_PROJECT_FORM:
      if (state.getIn(['form', 'isVisible'])) {
        return state.merge(
          fromJS({
            form: {
              isVisible: false,
              projectId: null,
              errors: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            form: {
              isVisible: true,
              projectId: action.projectId,
              errors: action.errors,
            },
          }),
        );
      }
    default:
      return state;
  }
};

export default projectListReducer;
